// extracted by mini-css-extract-plugin
export var divider = "_37-0";
export var dividerText = "_37-1";